.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: scroll;
  padding-top: 32px;

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .main-container {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  gz-image-repo {
    padding-top: calc(var(--spacer) * 4.6);
  }

  gz-image-repo::part(wrapper) {
    flex-direction: row;
  }

  gz-image-repo::part(slot-content) {
    margin-left: calc(var(--spacer) * 2);
    max-width: 400px;
  }

  .empty-description {
    color: var(--body-text-arrows-400);
    text-align: left;
  }

  .empty-title {
    text-align: left;
    margin-bottom: var(--spacer);
  }
}
